/**
 * Sentry Error Tracking — Display Client
 * ─────────────────────────────────────────────────────────────────────────────
 * Captures unhandled errors and performance metrics from airport displays.
 * Set VITE_SENTRY_DSN in environment to enable.
 */

import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.log("[Sentry] No DSN configured — error tracking disabled");
    return false;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE || "development",
    release: `fidsnet-display@${import.meta.env.VITE_APP_VERSION || "2.0.0"}`,

    // Performance monitoring (lower sample rate for displays — many devices)
    tracesSampleRate: import.meta.env.PROD ? 0.05 : 1.0,

    // Filter out non-actionable errors
    ignoreErrors: [
      "ResizeObserver loop",
      "AbortError",
      "Network Error",
      /^Loading chunk/,
      "Non-Error promise rejection captured",
    ],

    beforeSend(event) {
      // Don't send in dev unless explicitly forced
      if (import.meta.env.DEV && !import.meta.env.VITE_SENTRY_FORCE_DEV) {
        return null;
      }
      return event;
    },

    integrations: [Sentry.browserTracingIntegration()],
  });

  console.log("[Sentry] Initialized");
  return true;
}

export function setSentryDevice(deviceId, terminal, zone) {
  Sentry.setTags({
    deviceId: deviceId || "unpaired",
    terminal: terminal || "none",
    zone: zone || "none",
  });
}

export { Sentry };
